import {
  genericGetSingle,
  genericGetAll,
  genericUpdateSingle,
  genericCreateSingle,
  genericDeleteSingle,
} from "../helpers/apiCall";
import { StorageRule } from "../models";

/**
 * Gets all storage rules
 * @param params URLSearchParams
 * @returns Promise<{ storage_rules: StorageRule[] }>
 */
function getAll(
  params: URLSearchParams = null,
): Promise<{ storage_rules: StorageRule[] }> {
  return genericGetAll("storage_rules", params);
}

/**
 * Gets a single storage rule
 * @param id string
 * @returns Promise<{ storage_rule: StorageRule }>
 */
function getSingle(id: string): Promise<{ storage_rule: StorageRule }> {
  return genericGetSingle("storage_rules", id);
}

/**
 * Updates a single storage rule
 * @param id number | string
 * @param rule { [key: string]: string | number | boolean | Date | undefined }
 * @returns Promise<{ storage_rule: StorageRule }>
 */
function updateSingle(
  id: number | string,
  rule: { [key: string]: string | number | boolean | Date | undefined },
): Promise<{ storage_rule: StorageRule }> {
  return genericUpdateSingle("storage_rules", id, rule).then((response) => {
    return response;
  });
}

/**
 * Creates a new storage rule
 * @param rule { [key: string]: string | number | boolean | Date | undefined }
 * @returns Promise<{ storage_rule: StorageRule | Error }>
 */
function createSingle(rule: {
  [key: string]: string | number | boolean | Date | undefined;
}): Promise<{ storage_rule: StorageRule | Error }> {
  return genericCreateSingle("storage_rules", rule);
}

/**
 * Gets the count of storage rules
 * @param params URLSearchParams
 * @returns Promise<{ count: number }>
 */
function getCount(params: URLSearchParams = null): Promise<{ count: number }> {
  if (!params) params = new URLSearchParams();
  params.append("countOnly", "true");
  return genericGetAll("storage_rules", params);
}

/**
 * Deletes a single storage rule
 * @param id number | string
 * @returns Promise resolving when deletion completes
 */
function deleteSingle(
  id: number | string,
): Promise<{ deleted: boolean } | { error: string }> {
  return genericDeleteSingle("storage_rules", id);
}

export const storageRuleService = {
  getAll,
  getSingle,
  getCount,
  updateSingle,
  createSingle,
  deleteSingle,
};
